import { UPLOAD_SONVI } from "../actions/elements";
import { sendAlert } from "../actions/alerts";

import { put, takeEvery } from "redux-saga/effects";

import fireapi from "../../utils/firebaseapi";

export function* addDatabaseSaga(action) {
  try {
    const { metaData, data } = action.payload;
    const urlData = yield fireapi.uploadFiles(data);
    const firestoreData = { ...metaData, ...urlData };
    console.log({ firestoreData });
    yield fireapi.doAddDatabase(firestoreData);
    action.payload.navigate("/mainMap");
  } catch (error) {
    console.log(error);
    const severity = "error";
    const title = "Firebase";
    const content = "add to database error";
    yield put(sendAlert({ severity, title, content }));
  }
  // yield call(rsf.firestore.addDocument, 'scores', score)
}

export default function* rootSaga() {
  yield takeEvery(UPLOAD_SONVI, addDatabaseSaga);
}
